module.exports = __webpack_public_path__ + "img/partners4.3a51ad35.jpg";